import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";

@Model()
class FrontPageReport extends ApplicationRecord {
  static jsonapiType = "front_page_reports";

  @Attr({ persist: false }) archivedAt: string;

  @Attr() billable: boolean;

  @Attr() contentDate: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() excludedArticlesIds: number[];

  @Attr() includeFrontpages: boolean;

  @Attr() newspaperIds: number[];

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() pdfUrl: string;

  @Attr() recipients: string[];

  @Attr() status: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default FrontPageReport;
